// Tipos de amenities por defecto que se pueden crear
export const defaultAmenityTypes = [
  { name: 'Cancha de Fútbol', icon: '⚽' },
  { name: 'Cancha de Tenis', icon: '🎾' },
  { name: 'Barbacoa', icon: '🔥' },
  { name: 'Gimnasio', icon: '💪' },
  { name: 'Microcine', icon: '🎬' },
  { name: 'Piscina', icon: '🏊' },
  { name: 'Salón de Eventos', icon: '🎉' },
  { name: 'Quincho', icon: '🏡' },
  { name: 'Sala de Juegos', icon: '🎮' },
  { name: 'Cancha de Paddle', icon: '🏓' },
  { name: 'Sala de Reuniones', icon: '🏢' },
  { name: 'Terraza', icon: '🌅' },
  { name: 'Cancha de Básquet', icon: '🏀' },
  { name: 'Cancha de Vóley', icon: '🏐' },
  { name: 'Spa', icon: '🧘' },
]

// Función para obtener el ícono de un tipo de amenity
export const getAmenityTypeIcon = (amenityTypeName) => {
  const amenityType = defaultAmenityTypes.find(
    (type) => type.name === amenityTypeName
  )
  return amenityType ? amenityType.icon : '🏢'
}

// Opciones predefinidas para períodos de cancelación
export const cancellationPeriodValuesOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 12, label: '12' },
  { value: 24, label: '24' },
]

// Raw strings — match the backend yup oneOf(['hours','days','minutes']).
// 'minutes' is exposed too: the legacy options elided it and the form's
// `1→hours / else→days` translation collapsed it to 'days' silently.
export const cancellationPeriodUnitOptions = [
  { value: 'hours', label: 'Horas' },
  { value: 'days', label: 'Días' },
  { value: 'minutes', label: 'Minutos' },
]

// Opciones de duración comunes
export const durationOptions = [
  { value: 15, label: '15 minutos' },
  { value: 30, label: '30 minutos' },
  { value: 60, label: '1 hora' },
  { value: 90, label: '1.5 horas' },
  { value: 120, label: '2 horas' },
  { value: 180, label: '3 horas' },
  { value: 240, label: '4 horas' },
  { value: 300, label: '5 horas' },
  { value: 360, label: '6 horas' },
  { value: 420, label: '7 horas' },
  { value: 480, label: '8 horas' },
  { value: 720, label: '12 horas' },
  { value: 1440, label: '24 horas' },
]

// Motivos de no disponibilidad
export const unavailabilityReasons = [
  'Mantenimiento',
  'Reparaciones',
  'Evento especial',
  'Limpieza profunda',
  'Renovación',
  'Reserva administrativa',
  'Fuera de servicio',
  'Otro',
]
